import {
  Directive,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';

@Directive({
  selector: '[soho-trackdirty]'// tslint:disable-line
})

export class LMTrackDirtyDirective implements OnInit {
  @Input() searchForm: boolean;
  // No track dirty for search form
  @HostBinding('attr.data-trackdirty') get trackDirtyAttr() {
    return !this.searchForm;
  };

  ngOnInit() {

  }
}
